<div class="modal-header">
  <h3 class="modal-title">{{ 'Session Time will end soon' | translate }}</h3>
  <button type="button" class="close" (click)="closeClick()">
    <span aria-hidden="true">×</span>
  </button>
</div>
<div class="modal-body">
  <p>{{ 'If you don`t continue shopping to the end of timer, you will be redirected to the Home page' | translate }}</p>
  <p></p>
  <p class="inactive-timer">
    <app-inactive-timer></app-inactive-timer>
  </p>
</div>
<div class="modal-footer">
  <button class="btn btn-primary btn-dialog" (click)="closeClick()">{{ 'Ok' | translate }}</button>
</div>
